import { Chart as ChartJS } from 'chart.js';

export const dynamicBufferLinePlugin = (buffer: number) => ({
  id: 'bufferLine',
  afterDraw: (chart: ChartJS) => {
    const {
      ctx,
      chartArea: { left, right },
      scales: { y },
    } = chart;
    const bufferValue = buffer; // Use dynamic buffer value
    const zeroValue = 0;

    // Draw buffer line (solid red line)
    const bufferYPosition = y?.getPixelForValue(bufferValue);
    if (bufferYPosition) {
      ctx.save();
      ctx.strokeStyle = '#EF4444';
      ctx.lineWidth = 1;
      ctx.setLineDash([]);
      ctx.beginPath();
      ctx.moveTo(left, bufferYPosition);
      ctx.lineTo(right, bufferYPosition);
      ctx.stroke();

      // Add label
      ctx.fillStyle = '#EF4444';
      ctx.font = '12px sans-serif';
      ctx.fillText('Buffer Stock', right - 80, bufferYPosition - 5);
      ctx.restore();
    }

    // Draw emphasized zero line
    const zeroYPosition = y?.getPixelForValue(zeroValue);
    if (zeroYPosition) {
      ctx.save();
      ctx.strokeStyle = '#374151';
      ctx.lineWidth = 1;
      ctx.setLineDash([]);
      ctx.beginPath();
      ctx.moveTo(left, zeroYPosition);
      ctx.lineTo(right, zeroYPosition);
      ctx.stroke();
      ctx.restore();
    }
  },
});
